import React, { Component } from 'react';
import { flushSync } from 'react-dom';
import $ from "jquery";
import { WarningBox } from '../components/WarningBox';
import { Seperator } from '../components/Seperator';
import './css/Setup.css';
// import { MULTI_LANGUAGE } from './Layout';
import { cmsAccount, jsonHeaders } from '../components/NavMenu';

export class Setup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            devices: [],
            selectedDevice: null,
            model: "",
            orientation: null,
            deviceName: "",
            modelText: "",
            serialNumber: "",
            ortText: "",
            warningBox: false,
            warningMessage: "",
            warningDescription: "",
            warningStatus: ""
        };
    }

    componentDidMount() {
        const intervalId = setInterval(() => {
            if (cmsAccount) {
                this.fetchDevices();
                clearInterval(intervalId);
            }
        }, 100);
    }

    fetchDevices() {
        var requestOptions = {
            method: 'GET',
            headers: jsonHeaders,
            redirect: 'follow'
        };

        return fetch(`/api/devices/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                flushSync(() => {
                    this.setState({ devices: result })
                })
            })
    }

    deviceClick(uuid) {
        const item = document.getElementById(`device-item-${uuid}`);
        this.setState({
            selectedDevice: uuid
        })

        const devices = document.querySelectorAll('.device-element');
        devices.forEach(function (e) {
            const imgElement = e.querySelector('.component-1');

            if (item === e) {
                e.classList.add('device-item-selected');
                e.classList.remove('device-item');
                imgElement.style.display = null;
            }
            else {
                e.classList.add('device-item');
                e.classList.remove('device-item-selected');
                imgElement.style.display = "none";
            }
        })
        this.getDeviceDetails(uuid);
    }

    getDeviceDetails(uuid) {
        var requestOptions = {
            method: 'GET',
            headers: jsonHeaders,
            redirect: 'follow'
        };
        fetch(`/api/devices/${uuid}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                this.setState({
                    deviceName: result.name,
                    serialNumber: result.sn ? result.sn : "",
                    model: result.model,
                    orientation: result.orientation,
                    modelText: result.model ? result.model : "select model",
                    ortText: (result.orientation % 180 == 0 ? "Landscape " : "Portrait ") + `${result.orientation}°`
                })
            })
            .catch(error => console.log('error', error));
    }

    addDevice() {
        const uuid = prompt("Please enter device's uuid.");
        if (uuid == null)
            return;

        const sn = prompt("Please enter device's serial number.");
        if (sn == null)
            return;

        const name = prompt("Please enter device's name.");
        if (name == null)
            return;

        var requestOptions = {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify([{
                uuid: uuid,
                sn: sn,
                name: name,
                companyUUID: cmsAccount.companyUUID
            }]),
            redirect: 'follow'
        };

        fetch(`/api/devices/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.fetchDevices().then(() => {
                    $([document.documentElement, document.getElementById('device-set')]).animate({
                        scrollTop: $(`#device-item-${result[0].uuid}`).offset().top
                    }, 1000);
                    this.deviceClick(result[0].uuid);
                })
            })
    }

    showModel() {
        $('#model-menu').css('display', 'flex');
        $('#ort-menu').css('display', 'none');
    }

    showOrt() {
        $('#ort-menu').css('display', 'flex');
        $('#model-menu').css('display', 'none');
    }

    selectModel(modelName) {
        $('#model-menu').hide();
        this.setState({
            model: modelName,
            modelText: modelName
        })
    }

    selectOrt(ort) {
        this.setState({
            orientation: ort,
            ortText: (ort % 180 == 0 ? "Landscape " : "Portrait ") + `${ort}°`
        })
        $('#ort-menu').hide();
    }
    handleInput(event) {
        let element = event.target.parentNode;
        element.style.border = "2px solid #094EFF";
        element.style.padding = "7px 23px";
    }

    deleteConfirm() {
        this.setState({
            warningStatus: "delete",
            warningBox: true,
            warningMessage:
                <>
                    Deleting the device will permanently remove all its settings from the IoT service and will not be restored.
                    <br />
                    <br />
                    Do you want to continue?
                </>
        })
    }
    deleteDevice() {
        const { selectedDevice } = this.state;
        if (!selectedDevice) {
            alert('Select a device to delete.');
            return;
        }

        var requestOptions = {
            method: 'DELETE',
            headers: jsonHeaders,
            redirect: 'follow'
        };

        fetch(`/api/devices/${selectedDevice}`, requestOptions)
            .then(response => response.text())
            .then(result => {
                console.log(result)
                this.setState({
                    selectedDevice: null
                })
                this.fetchDevices()
            })
            .catch(error => console.log('error', error));
    }
    saveConfirm() {
        this.setState({
            warningStatus: "save",
            warningBox: true,
            warningMessage:
                <>
                    Changing the device setup might not match the attribute of the playlist in use.
                    <br />
                    <br />
                    Do you want to continue?
                </>,
            warningDescription: "(The playlist compatibility can be checked on the Devices Manager page.)"
        })
    }
    handleSave() {
        const { deviceName, serialNumber, selectedDevice, model, orientation } = this.state;
        console.log(orientation)
        if (!deviceName || !serialNumber)
            return;

        var raw = JSON.stringify({
            "name": deviceName,
            "model": model,
            "sn": serialNumber,
            "orientation": orientation
        });

        var requestOptions = {
            method: 'PUT',
            headers: jsonHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`/api/devices/${selectedDevice}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.fetchDevices();
                this.deviceClick(selectedDevice);
                this.getDeviceDetails(selectedDevice);
            })
            .catch(error => console.log('error', error));
    }

    render() {
        const { devices, deviceName, modelText, serialNumber, ortText, warningBox, warningMessage, warningDescription, warningStatus } = this.state;
        return (
            <>
                <div className="setup-page" onClick={(event) => {
                    var $target = $(event.target);
                    if (!$target.closest('#model-menu').length &&
                        $('#model-menu').is(":visible")) {
                        $('#model-menu').hide();
                    }

                    if (!$target.closest('#ort-menu').length &&
                        $('#ort-menu').is(":visible")) {
                        $('#ort-menu').hide();
                    }

                    if (!$target.closest('#input-device-name').length &&
                        $('#input-device-name').is(":visible")) {
                        $('#input-device-name').css({
                            "border": "",
                            "padding": ""
                        });
                    }
                    if (!$target.closest('#input-sn').length &&
                        $('#input-sn').is(":visible")) {
                        $('#input-sn').css({
                            "border": "",
                            "padding": ""
                        });
                    }
                }}>
                    <div className="all-device-container">
                        <div className="top-bar">
                            <div className="text" style={{ marginLeft: "25px" }} >
                                Device Name
                            </div>
                            <Seperator height={16} style={{ marginLeft: "149px" }} />
                            <div className="text" style={{ marginLeft: "11px" }}>
                                Model Name
                            </div>
                        </div>
                        <div className="device-set" id="device-set">
                            {devices.map((device) => {
                                return (
                                    <div key={device.id}>
                                        <div className="device-item device-element" id={`device-item-${device.uuid}`} deviceid={`${device.uuid}`}
                                            onClick={() => { this.deviceClick(device.uuid) }}>
                                            <div className="component-1" style={{ display: 'none' }}>
                                                <img src="icons/arrow-right-normal.svg" />
                                            </div>
                                            <div className="device-name">
                                                {device.name}
                                            </div>
                                            <div className="model-name">
                                                {device.model}
                                            </div>
                                        </div >
                                        <Seperator width={375} style={{ margin: "5px 0px" }} />
                                    </div>
                                )
                            })}
                        </div>
                        <div className="bottom-bar">
                            <div className="delete-button" onClick={() => { this.deleteConfirm() }}>
                                <div className="icon">
                                    <img src="icons/delete-3.svg" />
                                </div>
                                <div className="text">
                                    Delete
                                </div>
                            </div>
                            <div className="add-button" onClick={() => { this.addDevice() }}>
                                <div className="icon">
                                    <img src="icons/add-device.svg" />
                                </div>
                                <div className="text">
                                    Add Device
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="device-setup-container">
                        <div className="title">
                            Device Setup
                        </div>
                        <div className="info-set">
                            <div className="info-unit" style={{ gap: "32px" }} >
                                <div className="info-name">
                                    Device Name:
                                </div>
                                <div className="text-bar" id="input-device-name">
                                    <input className="text input" id="details-device-name" placeholder="name your device" required value={deviceName}
                                        onClick={(e) => { this.handleInput(e) }}
                                        onChange={(e) => {
                                            this.setState({ deviceName: e.target.value })
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="info-unit" style={{ gap: "36px" }} >
                                <div className="info-name">
                                    Select Model:
                                </div>
                                <div className="selector"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.showModel()
                                    }}>
                                    <div className="text" id="model-text" style={{ width: "544px" }} >
                                        {modelText}
                                    </div>
                                    <div className="component-1">
                                        <img src="icons/arrow-down-big.svg" />
                                    </div>
                                </div>
                                <div className="menu" id="model-menu">
                                    <div className="text" onClick={() => { this.selectModel('CP-25.3 / Kaleido / 25.3” / 3200 x 1800') }}>
                                        CP-25.3 / Kaleido / 25.3” / 3200 x 1800
                                    </div>
                                    <Seperator width={332} />
                                    <div className="text" onClick={() => { this.selectModel('CP-31.5 / Spectra / 31.5” / 2560 x 1440') }}>
                                        CP-31.5 / Spectra / 31.5” / 2560 x 1440
                                    </div>
                                </div>
                            </div>
                            <div className="info-unit" style={{ gap: "25px" }} >
                                <div className="info-name">
                                    Serial Number:
                                </div>
                                <div className="text-bar" id="input-sn">
                                    <input className="text input" id="serial-number" placeholder="enter the SN on the device rating lable" value={serialNumber}
                                        onClick={(e) => { this.handleInput(e) }}
                                        onChange={(e) => {
                                            this.setState({ serialNumber: e.target.value })
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="info-unit" style={{ gap: "44px" }}>
                                <div className="info-name">
                                    Orientation:
                                </div>
                                <div className="selector"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.showOrt();
                                    }}>
                                    <div className="text" id="ort-text" style={{ width: "100%" }} >
                                        {ortText}
                                    </div>
                                    <div className="component-1">
                                        <img src="icons/arrow-down-big.svg" />
                                    </div>
                                </div>
                                <div className="menu" id="ort-menu">
                                    <div className="text" onClick={() => { this.selectOrt(0) }}>
                                        Landscape (0°)
                                    </div>
                                    <Seperator width={332} />
                                    <div className="text" onClick={() => { this.selectOrt(90) }}>
                                        Portrait (90°)
                                    </div>
                                    <Seperator width={332} />
                                    <div className="text" onClick={() => { this.selectOrt(180) }}>
                                        Landscape (180°)
                                    </div>
                                    <Seperator width={332} />
                                    <div className="text" onClick={() => { this.selectOrt(270) }}>
                                        Portrait (270°)
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bottom-bar">
                            <div className="save-button" onClick={() => { this.saveConfirm() }}>
                                <div className="text">
                                    Save
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <WarningBox
                    shown={warningBox}
                    message={warningMessage}
                    description={warningDescription}
                    close={(yes) => {
                        if (yes) {
                            if (warningStatus == "delete")
                                this.deleteDevice();
                            else if (warningStatus == "save")
                                this.handleSave();
                        }
                        this.setState({ warningBox: false })
                    }}
                />
            </>
        );
    }
}